module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_NewCastle.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_NewCastle.png
// module id = 2088
// module chunks = 4